@if (guide) {
	<uc-article-container
		[loadingArticle]="false"
		[article]="guide"
		url="https://universitycompare.com/guides/students-managing-anxiety"
	/>
}
<div id="ad_stop">
	<!-- snigel desktop -->
	<div class="container hidden lg:block">
		<div class="adngin">
			<div id="adngin-incontent_1_dskt-0" class="mx-auto incontent_1_dskt-0"></div>
		</div>
	</div>
	<uc-recommended-unis-carousel />
</div>

<uc-sticky-lead-bar-renderer leadType="BOOK_EVENT" colorScheme="ROSE" />
